<template>
  <FileManager
    :isPermission="project.isPermission"
    :startPath="startPath"
    col="4"
    hide-tree
    :project="project"
  ></FileManager>
</template>

<script>
import FileManager from "@/components/FileManager/index.vue";
export default {
  components: { FileManager },
  props: {
    project: {
      type: Object,
    },
  },
  computed: {
    startPath() {
      const guid = this.project.guid;
      return `Project/${guid}`;
    },
  },
};
</script>

<style></style>
